export default {"src":"__ASTRO_ASSET_IMAGE__CVEbSZjL__","width":1440,"height":700,"format":"jpg"}